import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
    sendResetPasswordRequest,
    resetPasswordTenant,
} from "../../services/tenantProfile";

@Module({
  namespaced: true
})
export default class tenantProfile extends VuexModule {
  // state
  resetPasswordOtp = {}
  // actions

  @Action
    public async resetRequest(payload) {
        try {
        const data = await sendResetPasswordRequest(payload);
        this.context.commit("setResetPassword", data.response);
        return data;
        } catch (err) {
        throw err;
        }
    }
  @Action
    public async resetPassword(payload) {
        try {
        const data = await resetPasswordTenant(payload);
        return data;
        } catch (err) {
        throw err;
        }
    }


  // mutations

  @Mutation
  public setResetPassword(data: any) {
      this.resetPasswordOtp = data;
  }


  // getters
  
}
